import React from "react";
import {
  Box,
  Button,
  Flex,
  FormControl,
  FormLabel,
  Heading,
  SimpleGrid,
  Stack,
  Text,
  VStack,
} from "@chakra-ui/react";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import Select from "react-select";
import { closeCreateGroup } from "../../../../modules/admin-modules/models/Actions";
import MainModel from "../../../../components/Models/main-model";
import MainInput from "../../../../components/Form/input";
import {
  createGroupRequest,
  editGroupRequest,
} from "../../../../modules/admin-modules/groups/Actions";
const colourStyles = {
  control: (styles, state) => ({
    ...styles,
    width: "100%",
    backgroundColor: "#FAF2EB",
    color: "#1e1b17",
    borderRadius: "12px",
    borderColor: state.isFocused ? "#6A1E1E" : "#D8CEC3",
    borderWidth: "1px",
    boxShadow: state.isFocused ? "0 0 0 1px rgba(106, 30, 30, 0.22)" : "none",
    minHeight: "42px",
    ":hover": {
      borderColor: "#6A1E1E",
    },
  }),
  indicatorSeparator: () => ({ display: "none" }),
  placeholder: (styles) => ({
    ...styles,
    color: "#D8CEC3",
    fontWeight: 600,
    fontSize: "14px",
  }),
  singleValue: (styles) => ({
    ...styles,
    color: "#1e1b17",
    fontWeight: 600,
    fontSize: "14px",
  }),
  menu: (styles) => ({
    ...styles,
    borderRadius: "12px",
    overflow: "hidden",
    border: "1px solid #D8CEC3",
    boxShadow: "0 16px 40px rgba(74, 15, 31, 0.18)",
    zIndex: 50,
  }),
  option: (styles, state) => ({
    ...styles,
    fontSize: "14px",
    fontWeight: state.isSelected ? 800 : 600,
    color: state.isSelected ? "#E9E2DB" : "#4A0F1F",
    backgroundColor: state.isSelected
      ? "#4A0F1F"
      : state.isFocused
        ? "rgba(233, 226, 219, 0.7)"
        : "transparent",
    ":active": {
      backgroundColor: "rgba(216, 206, 195, 0.7)",
    },
  }),
};

const TYPE_OPTIONS = [
  { label: "Online", value: 0 },
  { label: "Center", value: 1 },
];

const AddGroup = ({ isAdd, data, setSelectedData }) => {
  const openGroup = useSelector((state) => state.model.isOpen2);
  const isLoading = useSelector((state) => state.groups.isLoading);
  const dispatch = useDispatch();

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: {
      name: data?.name || "",
      type:
        data?.type === 0 || data?.type === "0"
          ? 1
          : data?.type === 1 || data?.type === "1"
            ? 1
            : isAdd
              ? 0
              : undefined,
    },
    shouldUnregister: true,
  });

  const typeDefault =
    data?.type === 1 || data?.type === "1"
      ? TYPE_OPTIONS[1]
      : data?.type === 0 || data?.type === "0"
        ? TYPE_OPTIONS[0]
        : isAdd
          ? TYPE_OPTIONS[1]
          : undefined;

  const header = (
    <Box>
      <Heading
        fontSize="28px"
        fontWeight="800"
        color="#6A1E1E"
        fontFamily="'Amiri','Tajawal',sans-serif"
        textAlign="center"
      >
        {isAdd ? "Add group" : "Edit group"}
      </Heading>
      <Text
        fontSize="xs"
        mt={1}
        color="rgba(74, 15, 31, 0.6)"
        textTransform="uppercase"
        letterSpacing="0.12em"
        fontWeight="700"
        textAlign="center"
      >
        Name and delivery type
      </Text>
    </Box>
  );

  const onSubmit = (values) => {
    const formData = new FormData();
    const total = { ...data, ...values };
    const skip = new Set([
      "grade",
      "subject",
      "students",
      "lectures",
      "homeworks",
      "created_at",
      "updated_at",
    ]);
    for (const key of Object.keys(total)) {
      if (skip.has(key)) continue;
      const v = total[key];
      if (v === undefined || v === null) continue;
      if (typeof v === "object" && !(v instanceof File) && !Array.isArray(v)) continue;
      formData.append(key, v);
    }
    const action = () => {
      dispatch(closeCreateGroup());
      setSelectedData({});
      reset();
    };

    if (isAdd) {
      dispatch(createGroupRequest(formData, action));
    } else {
      formData.append("_method", "PUT");
      dispatch(
        editGroupRequest({
          id: data?.id,
          formData,
          action,
        })
      );
    }
  };

  const closeFunc = () => {
    dispatch(closeCreateGroup());
    setSelectedData({});
    reset();
  };

  return (
    <MainModel
      isLoading={isLoading}
      header={header}
      closeFunc={closeFunc}
      openVar={openGroup}
      buttonTitle={null}
      buttonFunc={handleSubmit(onSubmit)}
      size="lg"
      hideDefaultFooter
      contentProps={{
        dir: "ltr",
        bg: "#E9E2DB",
        borderRadius: "16px",
        overflow: "hidden",
        boxShadow: "2xl",
      }}
      headerProps={{
        px: 8,
        pt: 8,
        pb: 6,
        borderBottom: "1px solid rgba(216, 206, 195, 0.5)",
      }}
      bodyProps={{ px: 8, py: 8 }}
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <Stack spacing={6} dir="ltr" w="100%">
          <SimpleGrid columns={{ base: 1, md: 1 }} spacingY={6} alignItems="start">
            <MainInput
              label="Group name"
              defaultValues={data?.name}
              error={errors?.name?.message}
              placeholder="Enter group name"
              register={register}
              name="name"
            />

            <FormControl>
              <VStack align="stretch" spacing={2}>
                <FormLabel m={0} fontSize="14px" fontWeight="700" color="#6A1E1E" textAlign="left">
                  Delivery type
                </FormLabel>
                <Select
                  inputId="group_type"
                  options={TYPE_OPTIONS}
                  defaultValue={typeDefault}
                  onChange={(opt) => {
                    const v = opt?.value;
                    setValue("type", v, { shouldValidate: true, shouldDirty: true });
                  }}
                  styles={colourStyles}
                  placeholder="Select type"
                />
                <input type="hidden" {...register("type", { required: true })} />
              </VStack>
            </FormControl>
          </SimpleGrid>

          <Flex justify="flex-end" gap={6} pt={2}>
            <Button
              variant="ghost"
              color="#4A0F1F"
              fontWeight="800"
              _hover={{ textDecoration: "underline" }}
              onClick={closeFunc}
            >
              Cancel
            </Button>
            <Button
              type="submit"
              bg="#6A1E1E"
              color="white"
              borderRadius="lg"
              px={8}
              py={6}
              fontWeight="800"
              isLoading={isLoading}
              _hover={{ bg: "#4A0F1F" }}
              boxShadow="0 10px 24px rgba(106, 30, 30, 0.18)"
            >
              Save changes
            </Button>
          </Flex>
        </Stack>
      </form>
    </MainModel>
  );
};

export default AddGroup;
